import React from "react";
import { FormControl, ControlLabel, Alert } from "react-bootstrap";
import context from "./../lib/context.js";
import ajax from "./../lib/ajax.js";
import TCClockEditForm from "./tc-clock-edit/tc-clock-edit-form.jsx";
import moment from "moment";
import immutable from "immutable";
import TCButtonPanel from "./shared/tc-button-panel.jsx";
import { browserHistory } from "react-router";

export default class FutureTCClockEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            weekEndings: [],
            selectedTimecardId: null,
            selectedWeekEnding: null,
            timecard: null,
            hideButtonPanel: true,
            buttons: "",
            errors: []
        };

        this.role = context.getRouteParam(this, "role");

        this.onSelectedTimecardIdChanged = this.onSelectedTimecardIdChanged.bind(this);
        this.onNewTimecardAdded = this.onNewTimecardAdded.bind(this);
        this.onDeleteTimecard = this.onDeleteTimecard.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onLoadTimecardCompleted = this.onLoadTimecardCompleted.bind(this);
        this.deleteTimecard = this.deleteTimecard.bind(this);
    }

    onSelectedTimecardIdChanged(newValue) {
        const tokens = newValue.split("|");

        this.setState(immutable.fromJS(this.state)
            .mergeDeep({
                selectedTimecardId: parseInt(tokens[0]),
                selectedWeekEnding: moment(new Date(tokens[1])).format("MM/DD/YYYY")
            }).toJS());
    }

    onNewTimecardAdded(newTimecardId) {
        let self = this;
        ajax.vm()
            .get("people/future-tc-clock-edit")
            .then(function (res) {
                let data = res.data;
                console.log(res.data);
                data.selectedTimecardId = newTimecardId;

                for (let i = 0; i < data.weekEndings.length; i++) {
                    let item = data.weekEndings[i];
                    if (item.timecardId == newTimecardId) {
                        data.selectedWeekEnding = moment(item.weekEnding).format("MM/DD/YYYY");
                        break;
                    }
                }
                self.setState(res.data);
            });
    }

    onSubmit() {
        const self = this;
        const timecardId = this.state.selectedTimecardId;
        const vm = this.state;

        context.message({
            show: true,
            type: "loading",
            message: "Preparing to submit timecard..."
        });

        ajax.api()
            .put(`add-notes/${timecardId}`, {
                role: self.role,
                notes: self.refs.tcClockEditForm.refs.tcSummary.getNotes()
            })
            .then(res => {
                ajax.api()
                    .get(`prepare-timecard-submission/${timecardId}`)
                    .then(function (res) {
                        
                        if (res.data.errorMessages != null && res.data.errorMessages.length > 0) {
                            self.handleError(res.data.errorMessages, function () {
                                context.message({ show: false });
                            });
                        } else {
                            const submitToken = res.data.token
                            browserHistory.push(context.routeUrl(`people/tc-submit/${submitToken.timecardId}/${escape(submitToken.token)}`));
                            context.message({ show: false });
                        }
                    })
                    .catch(function (err) {
                        const clone = immutable.fromJS(vm).toJS();
                        let errors = [];
                        let data = err.response.data;
                        for (let k in data.data) {
                            errors.push(data.data[k]);
                        }
                        if (errors.length == 0) {
                            errors.push(data.exceptionMessage || data.message);
                        }

                        self.handleError(errors, function () {
                            context.message({ show: false });
                        });
                    });
            })
            .catch(err => {
                self.handleError(err.data.exceptionMessage || err.data.message, function () {
                    context.message({ show: false });
                });
            });
    }

    onDeleteTimecard() {
        let vm = this.state;
        const self = this;
        ajax.api()
            .get("timecard-has-unapproved-pto/" + vm.selectedTimecardId)
            .then(function (res) {

                let title = "";
                let msg = "Are you sure you want to delete this timecard?";
                let buttons = "yes,no";
                let type = "info";

                if (res.data) {
                    title = <span className="ap-pto-dialog-title"><i className="fa fa-calendar-o" /> Cancel Time-Off</span>;
                    msg = <div className="ap-mb-2"><b>This will cancel your Time-Off request.<br/>Are you sure you want to continue?</b></div>;
                    buttons = "continue,cancel";
                    type = "";
                }

                context.message({
                    show: true,
                    type: type,
                    title: title,
                    message: msg,
                    buttons: buttons
                }, function (button, s) {
                    // s is timecardId, timecardId is set as the 3rd parameter of context.message
                    if (button === "yes" || button === "continue") {
                        self.deleteTimecard(s)
                    }
                }, vm.selectedTimecardId);
            })
            .catch(function (err) {
                const data = err.response.data;
                const msg = data.exceptionMessage || data.message;
                context.message({
                    show: true,
                    type: "error",
                    message: <div>Error while deleting timecard.<br />{msg}</div>,
                    buttons: "ok"
                });
            });
    }

    deleteTimecard(timecardId) {
        const self = this;

        context.message({
            show: true,
            type: "loading",
            message: "Deleting Timecard. Please wait..."
        });
        ajax.api()
            .delete("delete-timecard/" + timecardId)
            .then(function (res) {
                self.loadPage();
                //browserHistory.push(context.routeUrl("people/tc-entry"));
            })
            .catch(function (err) {
                const data = err.response.data;
                const msg = data.exceptionMessage || data.message;
                context.message({
                    show: true,
                    type: "error",
                    message: <div>Error while deleting timecard.<br />{msg}</div>,
                    buttons: "ok"
                });
            });
    }

    componentDidMount() {
        this.loadPage();
    }

    loadPage() {
        const tid = this.props.location.query.tid;
        console.log(tid);
        let self = this;
        ajax.vm()
            .get("people/future-tc-clock-edit")
            .then(function (res) {
                const data = res.data;
                if (tid) {
                    for (let i = 0; i < data.weekEndings.length; i++) {
                        if (tid == data.weekEndings[i].timecardId) {
                            data.selectedTimecardId = data.weekEndings[i].timecardId;
                            data.selectedWeekEnding = data.weekEndings[i].weekEnding;
                        }
                    }
                }
                data.selectedWeekEnding = moment(data.selectedWeekEnding).format("MM/DD/YYYY");
                console.log(data.selectedWeekEnding);
                self.setState(data);
            });
    }

    onLoadTimecardCompleted(tc) {
        const clone = immutable.fromJS(this.state).toJS();
        const buttonConfig = this.prepareButtonPanel(tc);
        clone.timecard = tc;
        clone.hideButtonPanel = buttonConfig.hideButtonPanel;
        clone.buttons = buttonConfig.buttons;
        this.setState(clone);
    }

    prepareButtonPanel(tc) {

        const result = {
            hideButtonPanel: true,
            buttons: ""
        };
        if (tc) {
            if (tc.statusCode.toLowerCase() === "saved") {
                result.hideButtonPanel = false;
                result.buttons = "submit,delete";
            }
        }

        return result;
    }

    handleError(errors, callback) {
        const clone = immutable.fromJS(this.state).toJS();
        if ((typeof (errors)).toLowerCase() === "string") clone.errors = [errors];
        else clone.errors = errors;
        this.scrollTop = true;
        this.setState(clone, function () {
            callback();
        });
    }

    render() {
        let allowEdit = true;
        let alert = null, errors = null;
        const tc = this.state.timecard;

        if (tc && tc.statusCode.toLowerCase() !== "saved") {
            allowEdit = false;
            alert = <Alert bsStyle="danger">Timecard for the weekend {moment(tc.weekEnding).format("MM/DD/YYYY")} has been {tc.statusCode.toLowerCase()} already!</Alert>;
        }

        if (this.state.errors.length > 0) {
            errors = <Alert bsStyle="danger"><ul>
                {
                    this.state.errors.map(err => <li key={err}>{err}</li>)
                }
            </ul></Alert>
        }

        return (
            <div className="ap-form-container">
                <div className="container ap-top-margined">
                    <div className="row">
                        <div className="col-md-4 col-md-offset-4 text-center">
                            <ControlLabel>This timecard is for the week-ending</ControlLabel>
                            <FormControl componentClass="select" value={`${this.state.selectedTimecardId}|${this.state.selectedWeekEnding}`}
                                onChange={(evt) => this.onSelectedTimecardIdChanged(evt.target.value)}>
                                {this.state.weekEndings.map(we => <option key={we.timecardId} value={`${we.timecardId}|${moment(we.weekEnding).format("MM/DD/YYYY")}`}>{moment(we.weekEnding).format("MM/DD/YYYY")}</option>)}
                            </FormControl>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            {alert}
                            {errors}
                        </div>
                    </div>
                </div>
                <TCClockEditForm timecardId={this.state.selectedTimecardId} onNewTimecardAdded={this.onNewTimecardAdded}
                    onLoadTimecardCompleted={this.onLoadTimecardCompleted} weekEnding={this.state.selectedWeekEnding} hideGrid="true"
                    allowEdit={allowEdit} ref="tcClockEditForm" durationTcRoute={this.props.durationTcRoute}/>
                <TCButtonPanel buttons={this.state.buttons}
                    hidden={this.state.hideButtonPanel}
                    onSubmit={this.onSubmit}
                    onDelete={this.onDeleteTimecard} />
            </div>
        );
    }
}
